import { render, staticRenderFns } from "./HeadlineHeader.vue?vue&type=template&id=658d4678"
import script from "./HeadlineHeader.vue?vue&type=script&lang=js"
export * from "./HeadlineHeader.vue?vue&type=script&lang=js"
import style0 from "./HeadlineHeader.vue?vue&type=style&index=0&id=658d4678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports